module.exports = __webpack_public_path__ + "img/gatewayOffline.ce3dc704.png";